import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { StyleItem, StylesUploadUrlData } from '../types';

export function useStyleDetails(styleId: string) {
  const { data: uploadUrlData, refetch: refetchUploadUrl } =
    useApiQuery<StylesUploadUrlData>(`/styles/reupload-url/${styleId}`, {
      queryKey: ['styleDetailsUploadUrl'],
      initialData: null,
    });

  const { isFetching, data } = useApiQuery<StyleItem>(`/styles/${styleId}`, {
    queryKey: ['styleDetails'],
    initialData: null,
  });

  const updateStyleMutation = useApiMutation<StyleItem>(
    '/styles',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    uploadUrlData,
    details: data,
    refetchUploadUrl,
    updateStyleMutation,
  } as const;
}
